"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var config_1 = require("./config");

exports.getCenter = function (from, to) {
  return (to - from) / 2 + from;
};

exports.splitElementsAtTypes = function (types, elements) {
  var split = [];

  for (var _i = 0, elements_1 = elements; _i < elements_1.length; _i++) {
    var element = elements_1[_i];

    if (types.includes(element.type)) {
      break;
    } else {
      split.push(element);
    }
  }

  return split;
};

exports.calculateStep = function (count, isDistance) {
  if (isDistance === void 0) {
    isDistance = false;
  }

  var step = config_1.config.text.space * count + config_1.config.lines.space * count;

  if (isDistance) {
    step = step + config_1.config.text.space;
  }

  return step;
};

exports.getDocument = function () {
  var document;

  if (typeof window === 'undefined') {
    var jsdom = require('jsdom');

    var JSDOM = jsdom.JSDOM;
    document = new JSDOM("<!DOCTYPE html>").window.document;
  } else {
    document = window.document;
  }

  return document;
};

exports.isNumeric = function (num) {
  return !isNaN(num);
};

exports.toRadians = function (angle) {
  return angle * (Math.PI / 180);
};